import { ReactNode } from "react"
import { Sidebar } from "./Sidebar"
import { Navbar } from "./Navbar"

interface MainLayoutProps {
  children: ReactNode
}

export function MainLayout({ children }: MainLayoutProps) {
  return (
    <div className="min-h-screen bg-graphite-900 text-ink">
      <Sidebar />
      <div className="md:ml-60">
        <Navbar />
        <main className="p-4 md:p-6">{children}</main>
      </div>
    </div>
  )
}
